import { api } from './http'

// Alta / aprobación / SIFEN / consulta de comprobantes de venta.
// Reads VERIFICADOS EN VIVO (2026-06-25). Writes según CÓDIGO FUENTE (no se ejecutó POST real).

// --- Listado (Documentos emitidos) ---
// VIVO: GET /comprobanteventa?view=BaseList -> array; items con estado, cliente, numero, cdc, ...
export function listarComprobantes(params = {}) {
  return api.get('/comprobanteventa', { params: { view: 'BaseList', ...params } }).then((r) => r.data)
}

// --- Detalle por id ---
// El factory usa recuperarPorId/{id} y también get/{id}?view=...
export function getComprobante(id, view) {
  return api
    .get(`/comprobanteventa/recuperarPorId/${id}`, { params: view ? { view } : {} })
    .then((r) => r.data)
}

// --- Crear comprobante (flujo ágil) ---
// FUENTE: ComprobanteVentaFactory.saveWithPlanCobros -> POST /comprobanteventa?facturacionagil=true
//   (+ cantcuotas/plazocuotas/montoinicial si es a crédito con cuotas).
// // PENDIENTE: el shape del payload (montosImponibles por ítem/cabecera) requiere un POST real
// // para cerrarse — ver useFacturacionAgil.buildPayload. NO se ejecutó POST por ser read-only.
export function crearComprobante(payload, { facturacionAgil = true, planCobros } = {}) {
  const params = { facturacionagil: facturacionAgil }
  if (planCobros) Object.assign(params, planCobros) // { cantcuotas, plazocuotas, montoinicial }
  return api.post('/comprobanteventa', payload, { params }).then((r) => r.data)
}

// --- Aprobar ---
// VIVO (contrato): PUT /comprobanteventa/aprobarPorId/{id}. // PENDIENTE: validar con un PUT real.
export function aprobarComprobante(id) {
  return api.put(`/comprobanteventa/aprobarPorId/${id}`).then((r) => r.data)
}

// --- Envío a SIFEN (solo timbrado virtual) ---
// FUENTE: GET /comprobanteventa/generarJsonVirtual/{id} (opcional ?generarCdc=...).
// Solo se llama si timbrado.claseTimbrado.codigo === 'timbrado_virtual'. En este tenant el
// timbrado ágil es 'timbrado_autoimpreso' => NO se llama (impresión directa del KuDE/PDF).
export function generarJsonVirtual(id, generarCdc) {
  return api
    .get(`/comprobanteventa/generarJsonVirtual/${id}`, { params: generarCdc != null ? { generarCdc } : {} })
    .then((r) => r.data)
}
